import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import { getEnv } from './utils/env';

const firebaseConfig = {
    apiKey: getEnv('VITE_FIREBASE_API_KEY', 'AIzaSyAURZAbTKOrZPfEIzMcFuAra3gTI560xVg'),
    authDomain: getEnv('VITE_FIREBASE_AUTH_DOMAIN', 'connct-cba18.firebaseapp.com'),
    projectId: getEnv('VITE_FIREBASE_PROJECT_ID', 'connct-cba18'),
    storageBucket: getEnv('VITE_FIREBASE_STORAGE_BUCKET', 'connct-cba18.firebasestorage.app'),
    messagingSenderId: getEnv('VITE_FIREBASE_MESSAGING_SENDER_ID', '659625383784'),
    appId: getEnv('VITE_FIREBASE_APP_ID', '1:659625383784:web:fef6396ee51b861b2c28dd'),
    measurementId: getEnv('VITE_FIREBASE_MEASUREMENT_ID', 'G-VC4W8W953K'),
    databaseURL: getEnv('VITE_FIREBASE_DATABASE_URL', 'https://connct-cba18-default-rtdb.firebaseio.com')
};

// Debug logging
console.log('🔥 Firebase Config:', {
    apiKey: firebaseConfig.apiKey ? '✓ Set' : '✗ Missing',
    authDomain: firebaseConfig.authDomain,
    projectId: firebaseConfig.projectId,
    storageBucket: firebaseConfig.storageBucket,
    databaseURL: firebaseConfig.databaseURL
});


const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Realtime Database and get a reference to the service
export const database = getDatabase(app);

// Initialize Firebase Storage and get a reference to the service
export const storage = getStorage(app);

// Auth state ready promise - resolves when auth state is initialized
export const authStateReady = new Promise<void>((resolve) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
        console.log('🔐 Auth state changed:', user ? `User: ${user.uid}` : 'No user');
        unsubscribe();
        resolve();
    });
});

// Log when Firebase is ready
authStateReady.then(() => {
    console.log('✅ Firebase Auth state initialized');
    console.log('📍 Current auth user:', auth.currentUser?.uid || 'None');
});

export default app;
